(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', function () {
    var shopSummary = document.querySelector('.therra-nav__trigger') || document.getElementById('HeaderMenu-shop');
    var concernMenu = document.getElementById('ConcernMegaMenu');
    if (!shopSummary || !concernMenu) return;

    var shopDetails = shopSummary.closest('details');

    shopSummary.setAttribute('aria-expanded', 'true');

    shopSummary.addEventListener('click', function (e) {
      e.preventDefault();

      var isOpen = !concernMenu.hidden;

      if (isOpen) {
        concernMenu.hidden = true;
        shopSummary.setAttribute('aria-expanded', 'false');
      } else {
        concernMenu.hidden = false;
        shopSummary.setAttribute('aria-expanded', 'true');
      }

      if (shopDetails) {
        shopDetails.removeAttribute('open');
      }
    });

    document.addEventListener('click', function (e) {
      if (
        !concernMenu.hidden &&
        !concernMenu.contains(e.target) &&
        !shopSummary.contains(e.target) &&
        !(mobileToggle && mobileToggle.contains(e.target))
      ) {
        concernMenu.hidden = true;
        shopSummary.setAttribute('aria-expanded', 'false');
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !concernMenu.hidden) {
        concernMenu.hidden = true;
        shopSummary.setAttribute('aria-expanded', 'false');
        shopSummary.focus();
      }
    });

    var mobileToggle = document.getElementById('TherraMobileToggle');
    var headerEl = document.querySelector('.therra-header');

    if (mobileToggle && headerEl) {
      var openIcon = mobileToggle.querySelector('.therra-mobile-toggle__icon--open');
      var closeIcon = mobileToggle.querySelector('.therra-mobile-toggle__icon--close');

      mobileToggle.addEventListener('click', function () {
        var isOpen = headerEl.classList.toggle('therra-mobile-open');
        mobileToggle.setAttribute('aria-expanded', String(isOpen));

        if (openIcon) openIcon.hidden = isOpen;
        if (closeIcon) closeIcon.hidden = !isOpen;

        if (isOpen) {
          concernMenu.hidden = false;
          shopSummary.setAttribute('aria-expanded', 'true');
        } else {
          concernMenu.hidden = true;
          shopSummary.setAttribute('aria-expanded', 'false');
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && headerEl.classList.contains('therra-mobile-open')) {
          headerEl.classList.remove('therra-mobile-open');
          mobileToggle.setAttribute('aria-expanded', 'false');
          if (openIcon) openIcon.hidden = false;
          if (closeIcon) closeIcon.hidden = true;
          concernMenu.hidden = true;
          shopSummary.setAttribute('aria-expanded', 'false');
          mobileToggle.focus();
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
